import supabase from '../supabase/supabase';
import { TABLES } from './constants';

export { supabase };

export const checkConnection = async () => {
  try {
    const { error } = await supabase.from(TABLES.USERS).select('count', { count: 'exact', head: true });
    return !error;
  } catch (e) {
    return false;
  }
};